<template>
  <div id="app">
    <div id="wrongResolution">
      <img src="./assets/fulllogo.png">
      <h2>Resolution not supported for the prototype</h2>
      <h3>This prototype is only meant for the standard resolution of 375x812 of the iphone x</h3>
      <p>To simulate the resolution right click on the screen and go to inspector mode. A small window will open. Press on the icon of two mobile devices in the left top corner.</p>
      <p>You will notice that the screen changes but it is still not the correct resolution. In the new screen click in the top left corner in the dropdown and choice for IphoneX</p>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {

}
#wrongResolution{
  display: none;
}
#wrongResolution h2,h3, p{
  text-align: center;
  padding: 0px 20px;
}
/*@media screen and (max-width: 374px), (min-width: 376px) {*/
/*  #wrongResolution{*/
/*    position: fixed;*/
/*    display: flex;*/
/*    justify-content: center;*/
/*    align-items: center;*/
/*    background-color: white;*/
/*    width: 100%;*/
/*    height: 100%;*/
/*    overflow: hidden;*/
/*    z-index: 1000;*/
/*  }*/
/*}*/
/*@media screen and (max-height: 811px), (min-height: 813px) {*/
/*  #wrongResolution{*/
/*    position: fixed;*/
/*    display: flex;*/
/*    flex-direction: column;*/
/*    justify-content: center;*/
/*    align-items: center;*/
/*    background-color: white;*/
/*    width: 100%;*/
/*    height: 100%;*/
/*    overflow: hidden;*/
/*    z-index: 1000;*/
/*  }*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue